import { jsxs as t, Fragment as v, jsx as n } from "react/jsx-runtime";
import { ExpandButton as E } from "./index312.mjs";
import { SideNavHeader as B } from "./index313.mjs";
import { SIDE_NAV_COLLAPSED_WIDTH as h, SIDE_NAV_EXPANDED_WIDTH as x } from "./constants28.mjs";
import { useSideNav as $ } from "./useSideNav2.mjs";
import { isDefined as m, isTruthy as I } from "./types3.mjs";
import { StackPlaceholder as N, Wrapper as V, StackAside as b, HeaderSlot as _, FabSlot as A, StackNav as F, StackInner as H, FooterSlot as W } from "./styles114.mjs";
const X = ({
  body: u,
  fab: i,
  footer: d
}) => {
  const {
    api: a,
    canCollapse: o,
    sidebarRef: S,
    isExpanded: e,
    hideCollapseButton: f,
    expandOnHover: s
  } = $(), r = () => {
    a.toggleCollapse();
  }, l = (D) => {
    o && a.toggleExpanded(D);
  }, g = () => {
    s && l(!1);
  }, k = () => {
    s && l(!0);
  }, C = (o ? h : x) + 16, p = e ? x : h, c = !I(f);
  return /* @__PURE__ */ t(v, { children: [
    /* @__PURE__ */ n(N, { flexShrink: 0, width: C }),
    /* @__PURE__ */ t(V, { $width: p, $isExpanded: e, children: [
      c && !e && /* @__PURE__ */ n(E, { onClick: r }),
      /* @__PURE__ */ t(
        b,
        {
          component: "aside",
          $isExpanded: e,
          $canCollapse: o,
          onMouseEnter: k,
          onMouseLeave: g,
          ref: S,
          width: p,
          children: [
            c && e && /* @__PURE__ */ n(E, { onClick: r, inner: !0 }),
            /* @__PURE__ */ n(_, { $isExpanded: e, children: /* @__PURE__ */ n(B, {}) }),
            m(i) && /* @__PURE__ */ n(A, { $isExpanded: e, children: i }),
            /* @__PURE__ */ n(F, { component: "nav", $isExpanded: e, children: /* @__PURE__ */ n(H, { children: u }) }),
            m(d) && /* @__PURE__ */ n(W, { $isExpanded: e, children: d })
          ]
        }
      )
    ] })
  ] });
};
export {
  X as SideNavDesktopContainer
};
//# sourceMappingURL=index222.mjs.map
